import { useState, useEffect, useRef, useCallback } from "react"
import { DS } from './lib/ui'
import StockTab from './tabs/StockTab'
import IncidentsTab from './tabs/IncidentsTab'
import MenagesOpsTab from './tabs/MenagesOpsTab'
import MenageTodayView from './views/MenageTodayView'
import AccueilAdmin from './views/AccueilAdmin'
import EcranAccueil from './ecrans/accueil/EcranAccueil'
import EcranCalendrier from './ecrans/calendrier/EcranCalendrier'
import { EnteteOperations, VueMenages, OPERATIONS_TABS } from './ecrans/operations/EcranOperations'
import OperationsTaches from './ecrans/operations/OperationsTaches'
import { useAncienEcran } from './ecrans/useAncienEcran'
// LOT 1 OPÉRATEUR (ADR-303) — l'écran des décisions : la file des réponses
// prêtes, LE seul endroit qui envoie (guichet inbox_reply existant).
import OperateurView from './views/operateur/OperateurView'
import MenageCalendrierView from './views/MenageCalendrierView'
import MenageSuiviView from './views/MenageSuiviView'
// Écran de décision « Demandes d'horaires » (orchestrateur) — hub services horaires.
import OrchestrateurHorairesView from './views/OrchestrateurHorairesView'
import MenageAvisView from './views/MenageAvisView'
import AvecAncienEcran from './ecrans/AvecAncienEcran'
import EnteteOrch from './ecrans/orchestrateur/EnteteOrch'
import EcranStockOrch from './ecrans/orchestrateur/EcranStockOrch'
import EcranAvisOrch from './ecrans/orchestrateur/EcranAvisOrch'
import EcranReglages from './ecrans/reglages/EcranReglages'
import { compterManques } from './ecrans/reglages/reglages-calculs'
import ControleView from './views/menage/ControleView'
import MenageIncidentsView from './views/MenageIncidentsView'
import ComptaTab from './tabs/ComptaTab'
import MesTachesTab from './tabs/MesTachesTab'
import ParamsPanel from './tabs/ParamsPanel'
import MessagesPanel from './tabs/MessagesPanel'
import LogementsV2 from './views/logements/LogementsV2'
import CalendarPanel from './tabs/CalendarPanel'
import HistoriquePanel from './tabs/HistoriquePanel'
import { MONTHS, fmtE, fmtDate, addDays, formatMois, fmtJourMois } from './lib/format'
import { mapV2IncidentsToKv } from './lib/incidents-helpers'
import { listIncidents } from './lib/incidents-api'
import GardeEcran from './components/GardeEcran'
// Bandeau « nouvelle version en ligne » (incident 2026-09-22 : onglet resté sur
// le JavaScript d'avant #1470). Fail-open : ne s'affiche que si les deux
// empreintes de commit sont connues et différentes — src/lib/version-app.js.
import BandeauVersionPerimee from './components/BandeauVersionPerimee'
import BasculeEspace from './components/BasculeEspace'
import { getAllLogsFlat } from './lib/sousloc-helpers'
import { stockApi } from './lib/stock-api'
// Bandeau « je n'ai pas pu lire … » (Dimitri 2026-09-28 : « des écrans vides
// sans un mot, c'est moi qui prends une décision sur du néant en croyant voir
// mes vraies données »). Le refus vit dans src/lib/reponse-json.js.
import BandeauLectureIllisible from './components/BandeauLectureIllisible'
import BandeauGardeEcriture from './components/BandeauGardeEcriture'
// F13 : l'écran Argent affiche « — » (jamais 0) quand la lecture de facturation a raté.
import { lectureArgentRatee } from './lib/argent-lecture'
// v3 ÉTAPE 1 (read-path Beds24) — fraîcheur RÉELLE de la synchro Beds24 pour
// l'indicateur du bandeau (remplace l'heure du dernier clic iCal V1 legacy).
import { computeBeds24Freshness } from './lib/beds24-freshness'
import { INCIDENT_TYPES, INCIDENT_STATUS_MENAGE, INCIDENT_STATUS, STATUS_COLOR, MENAGE_STATUS_COLOR, INIT_CFG } from './lib/domain-constants'
import EndettementModal from './modals/EndettementModal'
import { analyseBusinessClaude } from './lib/ai-client'
import ProprioApp from './ProprioApp'
// LOT 3 (2026-08-26) — la destination ◷ Aujourd'hui : le chrome du proto
// (bandeau équipe + bascule à sept) et ses écrans NEUFS ; les trois reprises
// (planning, ménages, horaires) restent les écrans existants, rendus dessous.
// Lot Statistiques (2026-09) — l'écran refondu à deux modèles, remonté sous le
// chrome € Argent (remplace la phrase de révision ArgentStatsRevision).
import AdminStatsView from './views/AdminStatsView'
// Lot 6 (2026-09) — la destination ✉ Voyageurs : chrome à compteurs, Avis neuf,
// feuilles Demandes. Câblages conservés tels quels au merge du lot Statistiques.
import { EnteteVoyageurs, VueMessages } from './ecrans/voyageurs/EcranVoyageurs'
import VoyageursAvisCtrl from './views/voyageurs/VoyageursAvisCtrl'
import VoyageursDemandesCtrl from './views/voyageurs/VoyageursDemandesCtrl'

import JourControleCtrl from './views/jour/JourControleCtrl'
import JourIncidentsCtrl from './views/jour/JourIncidentsCtrl'
import JourStockCtrl from './views/jour/JourStockCtrl'
import JourTachesCtrl from './views/jour/JourTachesCtrl'
import MonTravail from './views/menage/MonTravail'
import { VOYAGEURS_TABS } from './app/onglets'
import { useSession } from './app/useSession'
import { useCompteursMenu, useBadgesGroupes } from './app/useCompteursMenu'
import { useFraicheurBeds24 } from './app/useFraicheurBeds24'
import { useControleRole } from './app/useControleRole'
import { ecranChargement, ecranConnexion } from './app/EcransAccueil'
import { construireMenu } from './app/menu'
import { barreDuHaut, navigationOnglets } from './app/Navigation'
import { useChargementDonnees } from './app/argent/useChargementDonnees'
import { enregistrements } from './app/argent/enregistrements'
import { useSynchroDonnees, useSynchroAuto } from './app/argent/useSynchroDonnees'
import { useProjectionArgent } from './app/argent/useProjectionArgent'
import { resasArgent } from './app/argent/resas'
import { resasAffichage } from './app/argent/resasAffichage'
import { factureEmission } from './app/argent/factureEmission'
import { useFacturesPieces } from './app/argent/useFacturesPieces'
import { rapportProprio } from './app/argent/rapport'
import { fenetresArgent } from './app/argent/FenetresArgent'
import { bandeauArgent } from './app/argent/BandeauArgent'
import { ecranDonnees } from './app/argent/EcranDonnees'
import { ecranFacturation } from './app/argent/EcranFacturation'

export default function App() {
  const now = new Date()
  const initM = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}`
  const [cfg,setCfg] = useState(() => INIT_CFG)
  // Les phrases à montrer quand une lecture de session a rendu autre chose
  // qu'une donnée (page HTML servie en 200…). Vide = rien à dire. Remplie à
  // CHAQUE chargement de session, jamais accumulée entre deux : une lecture
  // qui repasse doit faire disparaître son propre avertissement.
  const [lecturesIllisibles,setLecturesIllisibles] = useState([])
  // F13 — les données de facturation n'ont pas été lues (bandeau de lecture) :
  // l'écran Argent affiche « — » au lieu de chiffres calculés sur un vide, et
  // aucune facture ne peut être émise ni générée (relecture argent F13 suite).
  const argentLectureRatee = lectureArgentRatee(lecturesIllisibles)
  const [data,setData] = useState({})
  // Banner UI sticky quand la garde saveData refuse une écriture (cf. saveData
  // ligne ~190). Audit-finding F5 : avant ce fix, le refus était silencieux
  // (juste console.error + Sentry) — l'utilisateur croyait avoir sauvegardé.
  const [gardeAlert,setGardeAlert] = useState(null)
  const [factLog,setFactLog] = useState([])
  // État le plus frais du journal, lu par saveLog HORS de React (cf. createSaveLog).
  const factLogRef = useRef([])
  useEffect(() => { factLogRef.current = factLog }, [factLog])
  // BUG5 (résolu) : les BADGES (« factures en attente » + « ✓ Facturé » par
  // logement) ET l'impact de suppression LogementsPanel lisent désormais la
  // TABLE invoices (invoicesRaw via findBlockingCommission/hasCommissionInvoice,
  // #408), PLUS le factLog KV. Le state `factLog` ci-dessus ne sert plus qu'à la
  // purge KV rétrocompat de la cascade de suppression (saveLog, validée Dimitri)
  // — il n'est plus l'autorité d'aucun badge ni de l'historique.
  // Historique « Factures émises » : source = TABLE invoices (fiscale fiable),
  // alimenté par invoicesList (passé à HistoriquePanel), PAS le factLog KV.
  const [invoicesList,setInvoicesList] = useState([])
  // Pièces ARCHIVÉES (factures annulées par avoir + avoirs), même shape que
  // invoicesList. Séparé pour que la garde anti-double-facturation et le
  // « Total émis » restent calculés sur les seules pièces actives — et pour que
  // l'Historique puisse montrer qu'un avoir n'efface rien.
  const [invoicesArchiveList,setInvoicesArchiveList] = useState([])
  // Journal des envois de factures (2026-10-03, src/lib/journal-envois-facture.js) :
  // null = pas encore lu, JOURNAL_ILLISIBLE = lecture ratée (« — », jamais « non envoyée »).
  const [journalEnvois,setJournalEnvois] = useState(null)
  // Repère de SESSION (revue argent 2026-10-03) : factures dont l'envoi vient
  // de finir « incertain » ou « parti mais non noté » — « Envoyer » bloqué
  // jusqu'au rechargement, même si le journal ne le dit pas.
  const envoisBloquesSession = useRef(new Set())
  // P-2.46 bis : (logement, mois) dont la facture a été préparée pendant la
  // session (src/lib/facture-envoi-ecran.js) — tient même si la liste ne se relit pas.
  const facturesMoisBloquees = useRef(new Set())
  const bloquerEnvoiSession = (invoiceId, envoi) => {
    if (invoiceId && envoi && (envoi.etat === 'incertain' || envoi.etat === 'envoye_sans_preuve')) envoisBloquesSession.current.add(invoiceId)
  }
  // Case « je confirme » de la modale d'AVOIR. Jamais pré-cochée : un avoir
  // est irréversible (CGI 289), le bouton reste gris tant qu'elle ne l'est pas.
  const [confirmAvoirChecked,setConfirmAvoirChecked] = useState(false)
  // Case « je confirme » de la modale d'ENVOI de l'avoir. Même mécanique :
  // jamais pré-cochée. Ce mail part RÉELLEMENT (EmailJS tourne dans le
  // navigateur, aucune variable d'env ne le gate) et il annonce à un
  // propriétaire qu'une facture qu'il a reçue était fausse — cela se relit
  // avant de partir, pas après.
  const [confirmEnvoiAvoirChecked,setConfirmEnvoiAvoirChecked] = useState(false)
  // Lignes BRUTES de la table invoices (avant mapInvoiceRow) — source de vérité
  // de la garde anti-double-facturation commission proprio (findBlockingCommission).
  // Séparé d'invoicesList (shape aminci pour l'historique) volontairement.
  const [invoicesRaw,setInvoicesRaw] = useState([])
  // Passe à true après le 1er chargement réussi → tant que false, on ne peut pas
  // affirmer « pas encore facturé » (fenêtre de course : bouton Facture désactivé).
  const [invoicesLoaded,setInvoicesLoaded] = useState(false)
  const [incidents,setIncidents] = useState([])
  const [compta,setCompta] = useState(null)
  // Refonte stock 2026-04-29 : modèle dépôts/achats (cf. src/lib/depots-helpers.js).
  const [stockCentral,setStockCentral] = useState({})
  const [depots,setDepots] = useState([])
  const [achats,setAchats] = useState([])
  const [month,setMonth] = useState(initM)
  // PR4 commit 9 (NIT-2) : useState lazy init — l'ancien onglet 'pricing-config'
  // a été supprimé (ADR-095) et n'est plus jamais référencé côté code (vérifié
  // grep, pas de localStorage / URL params persistant l'onglet). Init direct
  // 'calendrier' suffit : le useEffect fallback redirect du commit 2 PR4 est
  // donc supprimé (évite un re-render initial inutile).
  // LOT 1 (2026-08-25) — l'admin ouvre sur l'ACCUEIL, plus sur le Calendrier.
  // ⚠️ Le rôle n'est pas connu au montage (currentUser arrive en asynchrone) :
  // les agents sont renvoyés vers leur défaut par la redirection de rôle plus
  // bas, et tout AUTRE rôle retombe sur 'calendrier' — sa destination d'avant,
  // inchangée. Aucun rôle ne peut atterrir sur un écran muet.
  const [tab,setTab] = useState(() => "accueil")
  // LOT 2 — le petit menu de la pastille « FZ · Réglages ▾ » (réglages +
  // déconnexion, arbitrage Dimitri 2026-08-26).
  const [menuPastille, setMenuPastille] = useState(false)
  // ⚠️ DESTINATION INTER-ÉCRANS (2026-08-11). Les trois écrans orchestrateur —
  // mois, frise, demandes d'horaires — ne se parlaient pas : on voyait un
  // problème dans l'un et il fallait changer d'onglet PUIS re-naviguer à la
  // main. `navDest` porte l'onglet visé, ce sur quoi l'ouvrir (un jour, une
  // demande) et LE CHEMIN DU RETOUR — un lien qui emmène sans ramener enferme.
  // La vue la consomme au montage puis l'efface (voir orchestrateur-navigation).
  const [navDest,setNavDest] = useState(null)
  const allerVers = useCallback((destination) => {
    if (!destination || !destination.onglet) return
    setNavDest(destination)
    setTab(destination.onglet)
  }, [])
  // CHANTIER OTA Lot O2 — lien « exception » de la carte Espace voyageur
  // (Paramètres) vers la fiche logement : la carte dépose l'id cible dans
  // sessionStorage ('fbz8-goto-logement') puis émet cet event ; on bascule
  // l'onglet, et LogementsPanel lit la cible à son mount pour sélectionner
  // la fiche. Zéro effet hors de ce parcours (event jamais émis ailleurs).
  useEffect(() => {
    const gotoLogements = () => setTab("logements")
    window.addEventListener("fbz:goto-logement", gotoLogements)
    return () => window.removeEventListener("fbz:goto-logement", gotoLogements)
  }, [])
  const [expanded,setExpanded] = useState({})
  const [expandedLogs,setExpandedLogs] = useState({})
  const [selectedLogId,setSelectedLogId] = useState(null)
  // Lot 6 — destination des compteurs dépliables du bandeau Voyageurs
  // (toucher une ligne emmène au bon endroit, déjà ouvert). Consommée une
  // fois par l'écran cible.
  const [voyDest, setVoyDest] = useState(null)
  // P-4.24 — L'ANCIEN ÉCRAN RESTE ATTEINTE depuis le nouveau, tant que les
  // portes d'écriture n'existent pas (bloquer, confier, créer, cocher…) :
  // aucun geste n'est retiré à l'admin. Vaut l'onglet dont l'ancien écran est
  // ouvert ; il se referme à chaque changement d'onglet (useAncienEcran).
  const { ouvert: ancienOuvert, ouvrir: setAncienEcran, fermer: fermerAncien } = useAncienEcran(tab)
  const retourNouveau = (
    <button type="button" className="fbz-press" data-testid="retour-nouvel-ecran" onClick={fermerAncien}
      style={{border:"1px solid #D6DDDA",background:"#fff",borderRadius:10,padding:"0 13px",minHeight:44,fontSize:12,fontWeight:600,cursor:"pointer",marginBottom:10}}>‹ Revenir au nouvel écran</button>
  )
  // Lot 5 (précision Dimitri 2026-08-28) : à l'OUVERTURE de Données, le
  // premier propriétaire est sélectionné — la fiche de droite n'ouvre plus
  // vide. ORDINATEUR SEULEMENT (≥768px, le point de bascule de .fbz-accueil) :
  // sur téléphone, sélectionner ouvrirait la feuille — comportement actuel
  // conservé. Ne rejoue qu'au changement d'onglet (déps [tab]) : décocher
  // reste possible sans re-sélection forcée.
  useEffect(() => {
    if (tab !== "donnees" || selectedLogId) return
    if (typeof window === "undefined" || !window.matchMedia("(min-width: 768px)").matches) return
    const premier = cfg?.props?.find(p => p.id !== "p6" && p.logs?.length)?.logs?.[0]
    if (premier) setSelectedLogId(premier.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, !!cfg])
  const [confirm,setConfirm] = useState(null)
  const [resaModal,setResaModal] = useState(null)
  // Lot 5c V2-prorata — modale de répartition au prorata (miroir resaModal).
  // MINEUR-1 (exclusivité mécanique) : son ouverture fait setResaModal(null), et
  // l'ouverture de resaModal fait setProrataModal(null) (render-guard XOR).
  const [prorataModal,setProrataModal] = useState(null)
  const [extraModal,setExtraModal] = useState(null)
  const [ajustModal,setAjustModal] = useState(null)


  const [y,m] = month.split("-").map(Number)
  const monthLabel = `${MONTHS[m-1]} ${y}`

  // Phase 6 PR4 commit 9 (NIT-2) — useEffect fallback redirect supprimé :
  // l'init useState lazy ci-dessus ('calendrier') suffit. Pas de persistance
  // tab détectée (ni localStorage ni URL params), donc aucun cas où
  // tab === 'pricing-config' au mount. Évite un re-render initial inutile.

  const {
    ready, currentUser, loginForm, setLoginForm, loginLoading, handleLogin, handleLogout,
  } = useSession({
    setTab,
  })

  useChargementDonnees({
    setCfg, setLecturesIllisibles, setData, setFactLog, setIncidents, setCompta, setStockCentral,
    setDepots, setAchats, currentUser,
  })

  // LOT Incidents 13 — refresh du state `incidents` après une écriture V2 dans
  // l'onglet Incidents (create / transition de statut). IncidentsTab gère son
  // propre reload local ; ce callback propage la fraîcheur aux AUTRES lecteurs
  // du state App (facture proprio, dashboard, alerte proprio) qui sinon restent
  // sur l'état périmé chargé au montage. Même mapping EXACT que le chargement
  // initial (listIncidents → mapV2IncidentsToKv avec propByLog résolu sur cfg).
  const refreshIncidents = useCallback(async () => {
    try {
      const incRows = await listIncidents({ limit: 1000 })
      const propByLog = new Map(
        (cfg ? getAllLogsFlat(cfg) : []).map(l => [l.id, l.propId])
      )
      setIncidents(mapV2IncidentsToKv(incRows, propByLog))
    } catch (e) { console.error('[incidents] refresh V2 failed', e) }
  }, [cfg])

  const {
    notif, aConfirmer, navBadgesIncidents, navBadgesAdmin,
    orchIncidentsAJuger, estOrchestrateurBadge, orchSansAgentJour, setOrchSansAgentJour,
    orchDemandesEnAttente,
  } = useCompteursMenu({
    incidents, currentUser,
  })


  const { saveCfg, saveCompta, saveData, montrerBandeauData, retirerBandeauData } = enregistrements({
    setCfg, setLecturesIllisibles, data, setData, setGardeAlert, setCompta, currentUser,
  })


  const {
    icalRefreshing, setSendingEmail, sendingEmail, setGenBusy, genBusy, setInvoiceSequences,
    invoiceSequences, setEmailSent, iaAnalyse, setIaAnalyse, setIaAnalyseLoading, iaAnalyseLoading,
    factureOpLock, refreshAllIcal, relireDonnees, saveLog, applyStockSnapshot,
  } = useSynchroDonnees({
    cfg, setData, setGardeAlert, setFactLog, factLogRef, setStockCentral, setDepots, setAchats,
    month, confirm, resaModal, prorataModal, extraModal, ajustModal, currentUser, saveData,
    montrerBandeauData, retirerBandeauData,
  })

  const {
    blocksByMonth, invalidatePricingBlocks, v2Lids, resasByLogement, skippedV2Ref, tombstonedV2Ref,
    getLogById, monthKeyToLabel, dataProjete, calc, aFacturer, lignesEnPlusFacture,
  } = useProjectionArgent({
    cfg, data, invoicesRaw, incidents, month, ready, currentUser, y, m,
  })

  useSynchroAuto({
    month, ready, currentUser, refreshAllIcal,
  })

  const { beds24Sync } = useFraicheurBeds24({ ready, currentUser })

  const { estControleur, setControleDest, controleDest } = useControleRole({ tab, setTab, currentUser })

  const { orchControlesATraiter, navBadges, navBadgeTons } = useBadgesGroupes({
    stockCentral, navBadgesAdmin, orchIncidentsAJuger, estOrchestrateurBadge, orchSansAgentJour,
    orchDemandesEnAttente, estControleur,
  })


  const {
    hasData, countIncompletesLog, countIncompletesLogWithChambres, navM, ensureEntry, saveResa,
    saveResaV2, deleteResaV2, restoreResaV2, moveResaV2, resolveNaturalResaV2, setProrataSplit,
    clearProrataSplit, createResaV2, deleteManualResa, moveResa, canMoveDir,
  } = resasArgent({
    data, invoicesRaw, month, setMonth, setConfirm, setResaModal, y, m, saveData, v2Lids,
    resasByLogement, getLogById, monthKeyToLabel, dataProjete,
  })
  const {
    renderOverrideBadge, renderMontantBadge, renderMenageBadge, renderMoveButtons,
    renderMoveButtonsV2, renderMoveBadgeV2, renderProrataButton, renderProrataBadge, deleteResa,
    saveExtra, deleteExtra, ajustFactEmise, motifVerrouAjust, saveAjust, deleteAjust,
  } = resasAffichage({
    data, invoicesRaw, month, setConfirm, setResaModal, setProrataModal, setExtraModal,
    setAjustModal, monthLabel, saveData, v2Lids, getLogById, monthKeyToLabel, ensureEntry,
    moveResaV2, resolveNaturalResaV2, setProrataSplit, clearProrataSplit, moveResa, canMoveDir,
  })

  const {
    sendFactureEmail, ouvrirEnvoiFactureExistante, envoyerFactureExistanteUI,
    variablesCourrielFacture, ouvrirEnvoiFacture, doGenFacture, callDeleteInvoice, mapInvoiceRow,
    relireFacturesPourImport, refreshInvoices, callSetInvoiceDelivered,
  } = factureEmission({
    cfg, argentLectureRatee, setInvoicesList, setInvoicesArchiveList, journalEnvois,
    setJournalEnvois, envoisBloquesSession, bloquerEnvoiSession, invoicesRaw, setInvoicesRaw,
    setInvoicesLoaded, incidents, month, setConfirm, y, m, monthLabel, setSendingEmail, setGenBusy,
    setEmailSent, factureOpLock, saveLog, dataProjete, ajustFactEmise, facturesMoisBloquees,
  })
  const {
    emettreBrouillon, callGetInvoiceSequences, callSetInvoiceSequence, callContractsOrphansList,
    callContractsOrphansDelete, handlePreviewFacture, deleteFactureCoherent, emitAvoir,
    resolveAvoirProprio, resolveAvoirEmailDest, findAvoirRemplacante, sendAvoir,
  } = useFacturesPieces({
    cfg, argentLectureRatee, data, invoicesList, invoicesArchiveList, setConfirmAvoirChecked, setConfirmEnvoiAvoirChecked, incidents, month, tab, setConfirm,
    currentUser, y, m, monthLabel, setInvoiceSequences, invoiceSequences, factureOpLock, saveLog,
    callDeleteInvoice, refreshInvoices, callSetInvoiceDelivered,
  })
  const { doGenRapport } = rapportProprio({
    cfg, argentLectureRatee, incidents, month, y, m, monthLabel, calc,
  })

  if (!ready) return (
    ecranChargement()
  )

  // ── Page de connexion ──
  if (!currentUser) return (
    ecranConnexion({ loginForm, setLoginForm, loginLoading, handleLogin })
  )

  // Permissions 42 Phase 2 — ESPACE PROPRIO dédié (rôle 'proprietaire', co-hôte).
  // Nav restreinte, LECTURE SEULE, cloisonnée aux logements du proprio (logIds du
  // JWT, cloisonnement DUR côté serveur). Le proprio ne voit JAMAIS les onglets
  // admin (Données globales, Compta, Prospection, Paramètres, Stock) ni l'espace
  // ménage. Branche AVANT le système d'onglets admin/menage (qui suppose cfg/data
  // admin chargés — non chargés pour le proprio).
  if (currentUser?.role === "proprietaire") {
    return <ProprioApp currentUser={currentUser} onLogout={handleLogout} />
  }

  const isAdmin = currentUser?.role === "admin"
  const isMenage = currentUser?.role === "menage"
  // Permissions 42 Phase 3 Lot 0 — l'orchestrateur est un AGENT (sur-ensemble du
  // ménage : mêmes onglets, mêmes runs). isAgentUI gouverne TOUT comportement
  // « agent » côté UI. En Lot 0, isAgentUI === menu/onglets/runs ménage à
  // l'identique — AUCUN onglet ni bouton orchestrateur (vue équipe/assignation =
  // Lots 1-5). Inerte sur les droits.
  const isOrchestrateur = currentUser?.role === "orchestrateur"
  const isAgentUI = isMenage || isOrchestrateur

  const {
    CATEGORIES, activeCategory, ENTREES_PLANNING, basculePlanningMobile, setCategory,
  } = construireMenu({ tab, setTab, estControleur, isAdmin, isOrchestrateur })

  const cardStyle = {background:DS.white,borderRadius:16,boxShadow:"0 1px 4px rgba(33,83,135,.06), 0 4px 16px rgba(33,83,135,.08)",overflow:"hidden",marginBottom:12}
  const sectionTitle = (t) => <div style={{fontFamily:DS.fontDisplay,fontSize:16,fontWeight:700,color:DS.navy,marginBottom:14}}>{t}</div>

  // v3 ÉTAPE 1 (read-path Beds24) — fraîcheur réelle Beds24 pour l'indicateur
  // du bandeau (dérivée à chaque render, calcul trivial). null tant qu'aucun
  // signal Beds24 n'est chargé (non-admin / avant 1er fetch).
  const beds24Freshness = beds24Sync ? computeBeds24Freshness(beds24Sync) : null

  return (
    <div className="fbz-app" style={{fontFamily:DS.fontBody}}>
      <BandeauLectureIllisible messages={lecturesIllisibles} />
      <BandeauVersionPerimee />
      {/* ⚖ CHEMIN ARGENT — le texte vit dans le composant, qui explique
          pourquoi `gardeAlert.message` DOIT être lu (il ne l'était pas). */}
      <BandeauGardeEcriture alerte={gardeAlert} onFermer={() => setGardeAlert(null)} />
      {fenetresArgent({
        cfg, argentLectureRatee, data, invoicesArchiveList, confirmAvoirChecked,
        setConfirmAvoirChecked, confirmEnvoiAvoirChecked, setConfirmEnvoiAvoirChecked, month,
        confirm, setConfirm, resaModal, setResaModal, prorataModal, setProrataModal, extraModal,
        setExtraModal, ajustModal, setAjustModal, currentUser, monthLabel, saveData, sendingEmail,
        genBusy, invoiceSequences, iaAnalyse, setIaAnalyse, saveResa, saveResaV2, deleteResaV2,
        createResaV2, deleteManualResa, deleteResa, saveExtra, deleteExtra, saveAjust, deleteAjust,
        sendFactureEmail, envoyerFactureExistanteUI, variablesCourrielFacture, ouvrirEnvoiFacture,
        doGenFacture, emettreBrouillon, handlePreviewFacture, deleteFactureCoherent, emitAvoir,
        resolveAvoirProprio, resolveAvoirEmailDest, findAvoirRemplacante, sendAvoir,
      })}

      {barreDuHaut({
        setTab, tab, setMenuPastille, menuPastille, handleLogout, icalRefreshing, navBadges,
        navBadgeTons, isAdmin, isMenage, isOrchestrateur, CATEGORIES, activeCategory, setCategory,
        beds24Freshness, currentUser,
      })}

      {navigationOnglets({
        setTab, tab, notif, aConfirmer, navBadgesIncidents, navBadges, isAdmin, isMenage,
        isOrchestrateur, CATEGORIES, activeCategory, setCategory,
      })}

      <div className="fbz-content">
       {/* LE BANDEAU DE SECOURS (Dimitri 2026-08-28) : la garde enveloppe TOUT
           le contenu sous la navigation — un écran qui casse est remplacé par
           le bandeau, le menu reste vivant. key={tab} : changer d'onglet
           remet la garde à zéro. */}
       <GardeEcran key={tab} tab={tab}>

        {/* NAV 7→4 (2026-08-19) — les BASCULES de groupe, sous la barre.
            ⚠️ RENDUES EN TÊTE DE TOUTE LA ZONE DE CONTENU (2 défauts mesurés le
            2026-08-19, MÊME FAMILLE ordre-du-DOM : posées après la vue Mois puis
            après l'écran Incidents, elles atterrissaient EN BAS de page).
            Ici, AUCUN onglet ne peut se rendre avant elles.
            Planning (Aujourd'hui / Le mois) et À décider (Demandes /
            Incidents / Contrôle, chacune avec SA pastille). Les ids d'onglets
            internes ne bougent pas. */}
        {/* MOBILE (spec 2026-08-22 §1) : la bascule vit SOUS le bandeau — la
            copie du haut se cache sous 860, chaque vue rend la sienne. */}
        <style>{'@media (max-width:860px){.fbz-bascule-haut{display:none}} @media (min-width:861px){.fbz-bascule-sous-bandeau{display:none}}'}</style>
        {isOrchestrateur && (tab === "menage-suivi" || tab === "menage-calendrier") && (
          <div className="fbz-tab-wide fbz-bascule-haut" style={{paddingBottom:0}}>
            <BasculeEspace testId="bascule-planning" actif={tab} onChange={setTab}
              entrees={ENTREES_PLANNING} />
          </div>
        )}
        {/* P-4.11 — l'en-tête à six tuiles (maquette v677), sauf sur Avis. */}
        {isOrchestrateur && tab !== "menage-avis" && <EnteteOrch onTab={setTab} estControleur={estControleur}/>}

        {/* ══ ◷ AUJOURD'HUI (lot 3) — le chrome du proto pour l'ADMIN :
            bandeau « La journée de l'équipe » + bascule à sept. Les trois
            reprises (planning · ménages · horaires) se rendent DESSOUS,
            telles quelles ; les quatre neufs remplacent leurs écrans. */}
        {/* P-4.24 — Opérations NEST : l'en-tête à six tuiles et ses six
            sous-onglets (maquette v677), lus par les portes du serveur. */}
        {isAdmin && OPERATIONS_TABS[tab] && (
          <EnteteOperations tab={tab} onTab={setTab} />
        )}

        {/* ══ ✉ VOYAGEURS (lot 6) — le chrome du proto pour l'ADMIN :
            bandeau 4 compteurs réels (fail-soft « — ») + bascule à quatre.
            Messages/Textes se rendent DESSOUS tels quels ; Avis et
            Demandes sont les écrans neufs du lot. */}
        {isAdmin && VOYAGEURS_TABS[tab] && (
          <div className="fbz-tab-content" style={{ paddingBottom: 0 }}>
            {/* P-4.24 — Voyageurs NEST : quatre tuiles, quatre sous-onglets, lus par les portes. */}
            <EnteteVoyageurs tab={tab} onTab={setTab} onDestination={setVoyDest} />
          </div>
        )}

        {bandeauArgent({
          cfg, argentLectureRatee, incidents, compta, month, tab, setTab, y, m, monthLabel,
          blocksByMonth, dataProjete, calc, navM, isAdmin,
        })}

        {ecranDonnees({
          cfg, argentLectureRatee, invoicesRaw, invoicesLoaded, incidents, month, tab, setTab,
          selectedLogId, setSelectedLogId, y, m, monthLabel, dataProjete, calc, aFacturer,
          lignesEnPlusFacture, hasData, countIncompletesLogWithChambres, cardStyle,
        })}


        {ecranFacturation({
          cfg, argentLectureRatee, data, factLog, invoicesRaw, invoicesLoaded, incidents, month,
          tab, setTab, expanded, setExpanded, setConfirm, setResaModal, setProrataModal,
          setExtraModal, setAjustModal, y, m, monthLabel, saveData, montrerBandeauData,
          relireDonnees, blocksByMonth, resasByLogement, skippedV2Ref, tombstonedV2Ref,
          monthKeyToLabel, dataProjete, calc, aFacturer, lignesEnPlusFacture, hasData,
          countIncompletesLog, countIncompletesLogWithChambres, restoreResaV2, renderOverrideBadge,
          renderMontantBadge, renderMenageBadge, renderMoveButtons, renderMoveButtonsV2,
          renderMoveBadgeV2, renderProrataButton, renderProrataBadge, ajustFactEmise,
          motifVerrouAjust, mapInvoiceRow, relireFacturesPourImport, doGenRapport, cardStyle,
        })}

        {/* ══ INCIDENTS ══
            Phase 4 cascade PR #135/138 — split par role pour respecter
            rules-of-hooks (early return interdit dans IncidentsTab). */}
        {/* B2 (Permissions 42 Phase 3 Lot 0) — l'orchestrateur est un AGENT :
            même vue ménage des incidents (cloisonnée à SES runs), jamais la vue
            ADMIN. isAgentUI = isMenage || isOrchestrateur. */}
        {tab==="incidents" && isAgentUI && <div className="fbz-tab-content"><MenageIncidentsView basculePage={null} cfg={cfg} currentUser={currentUser}/></div>}
        {tab==="incidents" && !isAgentUI && <div className="fbz-tab-content"><JourIncidentsCtrl cfg={cfg} currentUser={currentUser} onIncidentsChanged={() => { refreshIncidents() }}/></div>}

        {/* LOT Ménages dans Opérations — sous-onglet ADMIN uniquement (les agents
            sont redirigés par la whitelist de rôles ; double garde isAdmin ici). */}
        {tab==="menages" && isAdmin && !ancienOuvert("menages") && <VueMenages onAncien={() => setAncienEcran("menages")}/>}
        {tab==="menages" && isAdmin && ancienOuvert("menages") && <div className="fbz-tab-content">{retourNouveau}<MenagesOpsTab cfg={cfg} currentUser={currentUser} onNavigate={setTab} stockCentral={stockCentral} onControler={(run)=>{ setControleDest({ runId: run.id }); setTab('menage-controle') }}/></div>}

        {/* Phase 4 PR 4 + PR #134 (ADR-076) — Vues rôle ménage */}
        {tab==="menage-today" && <div className="fbz-tab-content"><MenageTodayView estControleur={estControleur} onControler={(m)=>{ setControleDest({ runId: m.run_id }); setTab('menage-controle') }} cfg={cfg} currentUser={currentUser} onNavigate={setTab}/></div>}
        {tab==="mon-travail" && isMenage && <div className="fbz-tab-content"><MonTravail cfg={cfg} currentUser={currentUser}/></div>}
        {/* N5 — clic-jour du Mois : le détail des ménages se DÉPLIE désormais INLINE
            sous la grille (MenageDayDetail), plus de navigation vers un autre onglet.
            MenageCalendrierView gère selectedDayIso en interne. Ce câblage est
            menage/orchestrateur-only : les calendriers admin/proprio (composants
            distincts) ne sont PAS concernés. */}
        {/* ⚠️ `fbz-tab-wide`, COMME SUIVI ÉQUIPE (1100 px et non 860). Le mois
            vivait dans le conteneur étroit : sa colonne de contexte se
            retrouvait 250 px plus à gauche que celle de la frise, et passer
            d'un onglet à l'autre donnait l'impression de changer
            d'application. */}
        {tab==="menage-calendrier" && <div className="fbz-tab-wide"><MenageCalendrierView basculePage={basculePlanningMobile} cfg={cfg} currentUser={currentUser} destination={navDest} onAller={allerVers} onDestinationConsommee={()=>setNavDest(null)} onControler={estControleur ? (run)=>{ setControleDest({ runId: run.id }); setTab('menage-controle') } : null}/></div>}
        {/* Lot 4 — Suivi équipe : rendu DOUBLEMENT gardé (tab + isOrchestrateur). */}
        {tab==="menage-suivi" && isOrchestrateur && <div className="fbz-tab-wide"><MenageSuiviView basculePage={basculePlanningMobile} cfg={cfg} currentUser={currentUser} onNavigate={setTab} stockCentral={stockCentral} destination={navDest} onAller={allerVers} onDestinationConsommee={()=>setNavDest(null)} onControler={estControleur ? (run)=>{ setControleDest({ runId: run.id }); setTab('menage-controle') } : null} controlesATraiter={estControleur ? orchControlesATraiter : 0} onSansAgentJour={setOrchSansAgentJour}/></div>}
        {/* Demandes d'horaires (hub services horaires) : orchestrateur ET admin
            (fix cul-de-sac 2026-08-14 : la carte « Demandes » du Suivi monté par
            MenagesOpsTab naviguait ici, où l'admin ne trouvait RIEN). L'admin
            arrive en LECTURE SEULE — l'accord est un geste d'argent, il passe
            par son mode « Modifier » local à la vue. L'auth serveur acceptait
            déjà les deux rôles (requireRole admin+orchestrateur). */}
        {/* ⚠️ `currentUser` est INDISPENSABLE : l'écran lit `menage_runs` par la
            RLS de l'orchestrateur (pool ∧ logIds) pour connaître la durée
            d'exception, l'agent à prévenir et l'heure de début du ménage. Sans
            lui, `computeVisibleEmails` rend une liste vide, aucun ménage n'est
            chargé, et l'écran retombe silencieusement sur le seuil du logement
            en perdant l'avertissement « ménage commencé ». */}
        {tab==="orchestrateur-horaires" && (isOrchestrateur || isAdmin) && <div className="fbz-tab-content"><OrchestrateurHorairesView basculePage={null} currentUser={currentUser} destination={navDest} onAller={allerVers} onDestinationConsommee={()=>setNavDest(null)} onNavigate={setTab}/></div>}
        {/* Avis N2 — lecture seule, ménage ET orchestrateur. Scope + anti-PII serveur (N1). */}
        {tab==="menage-avis" && isOrchestrateur && <EcranAvisOrch/>}
        {tab==="menage-avis" && !isOrchestrateur && <div className="fbz-tab-content"><MenageAvisView cfg={cfg} currentUser={currentUser}/></div>}
        {/* CONTRÔLE DES MÉNAGES — doublement gardé (tab + estControleur) ; la vue
            se défend aussi seule (403 serveur → rien). Périmètre = serveur. */}
        {tab==="menage-controle" && estControleur && !isAdmin && <div className="fbz-tab-content"><ControleView basculePage={null} cfg={cfg} currentUser={currentUser} destination={controleDest} onDestinationConsommee={()=>setControleDest(null)}/></div>}
        {tab==="menage-controle" && isAdmin && <div className="fbz-tab-content"><JourControleCtrl cfg={cfg} currentUser={currentUser} onNavigate={setTab}/></div>}

        {/* ══ HISTORIQUE ══ */}
        {/* P-4.11 — le Stock de la maquette v677 ; l'ancien écran reste atteint (confier, régler un manque). */}
        {tab==="stock" && isOrchestrateur && <AvecAncienEcran
          nouvel={(ouvrir) => <EcranStockOrch cfg={cfg} stockCentral={stockCentral} stockApi={stockApi} applyStockSnapshot={applyStockSnapshot} onAncien={() => ouvrir()}/>}
          ancien={() => <div className="fbz-tab-content"><StockTab cfg={cfg} depots={depots} achats={achats} stockCentral={stockCentral} stockApi={stockApi} applyStockSnapshot={applyStockSnapshot} fmtE={fmtE} formatMois={formatMois} fmtJourMois={fmtJourMois} month={month} navM={navM} isAdmin={isAdmin} currentUser={currentUser}/></div>}/>}
        {tab==="stock" && isAdmin && <div className="fbz-tab-content"><JourStockCtrl cfg={cfg} currentUser={currentUser} stockApi={stockApi} applyStockSnapshot={applyStockSnapshot}
          enfantsOutils={<StockTab masquerEcran cfg={cfg} depots={depots} achats={achats} stockCentral={stockCentral} stockApi={stockApi} applyStockSnapshot={applyStockSnapshot} fmtE={fmtE} formatMois={formatMois} fmtJourMois={fmtJourMois} month={month} navM={navM} isAdmin={isAdmin} currentUser={currentUser}/>}/></div>}

        {tab==="historique" && <div className="fbz-tab-content">
          <HistoriquePanel cfg={cfg} factLog={invoicesList} factLogKv={factLog} archive={invoicesArchiveList}
            onEmettre={(facture) => setConfirm({type:"emettreBrouillon", facture})}
            onEnvoyer={ouvrirEnvoiFactureExistante}
            onEssai={(f) => ouvrirEnvoiFactureExistante(f, { essaiSeulement: true })}
            onDelete={(facture) => setConfirm({type:"deleteFacture", facture})}
            onAvoir={(facture) => { setConfirmAvoirChecked(false); setConfirm({type:"avoirFacture", facture}) }}
            onSendAvoir={(facture) => { setConfirmEnvoiAvoirChecked(false); setConfirm({type:"envoiAvoir", facture}) }} />
        </div>}

        {/* Lot Statistiques (2026-09) : l'écran refondu à DEUX MODÈLES est
            REMONTÉ sous le chrome € Argent — conciergerie (commission) et
            sous-location (marge = CA − loyer − charges, mêmes fonctions que
            Compta) séparées, jamais mélangées dans un même chiffre. La phrase
            de révision (ArgentStatsRevision) est retirée. */}
        {tab==="stats-admin"&&<div className="fbz-tab-content"><AdminStatsView cfg={cfg} dataProjete={dataProjete} blocksByMonth={blocksByMonth} lectureRatee={argentLectureRatee}/></div>}
        {tab==="compta"&&<div className="fbz-tab-content"><ComptaTab sansMonthNav lectureRatee={argentLectureRatee} cfg={cfg} data={dataProjete} blocksByMonth={blocksByMonth} calc={calc} month={month} y={y} m={m} navM={navM} depots={depots} compta={compta} saveCompta={saveCompta} incidents={incidents} onAnalyse={async()=>{ setIaAnalyseLoading(true); try { const res = await analyseBusinessClaude(cfg,dataProjete,month,y,m,incidents); setIaAnalyse(res) } catch(e) { alert("Erreur Claude : "+e.message) } setIaAnalyseLoading(false) }} iaAnalyseLoading={iaAnalyseLoading}/></div>}
        {tab==="messages"&&!isAdmin&&<div className="fbz-tab-wide"><MessagesPanel cfg={cfg} notif={notif} vue={null} destinationThreadId={voyDest?.type==="thread"?voyDest.id:null} onDestinationConsommee={()=>setVoyDest(null)}/></div>}
        {/* P-4.24 — la liste NEST des conversations (porte ecran_conversations_lire) ;
            « Ouvrir la conversation » garde l'écran de réponse existant (l'envoi
            est une écriture, hors de ce lot ; le fil complet n'a pas encore de porte). */}
        {tab==="messages"&&isAdmin&&voyDest?.type!=="conversation"&&<VueMessages filInitial={voyDest?.type==="thread"?voyDest.id:null} onOuvrirConversation={(id)=>setVoyDest({ type: "conversation", id })}/>}
        {tab==="messages"&&isAdmin&&voyDest?.type==="conversation"&&<div className="fbz-tab-wide">
          <button type="button" className="fbz-press" data-testid="voy-retour-liste" onClick={()=>setVoyDest(null)} style={{border:"1px solid #D6DDDA",background:"#fff",borderRadius:10,padding:"0 13px",minHeight:44,fontSize:12,fontWeight:600,cursor:"pointer",marginBottom:10}}>‹ Toutes les conversations</button>
          <MessagesPanel cfg={cfg} notif={notif} vue="message" destinationThreadId={voyDest.id} onDestinationConsommee={()=>{}}/></div>}
        {/* LOT 2 — les quatre écrans de « Voyageurs » : le MÊME panneau,
            piloté par le menu. Les ids sont nouveaux, les écrans repris. */}
        {tab==="voyageurs-textes"&&isAdmin&&<div className="fbz-tab-wide"><MessagesPanel cfg={cfg} notif={notif} vue="template"/></div>}
        {/* Lot 6 : écran Avis NEUF (VoyageursAvisCtrl). L'ancien écran vit
            toujours dans MessagesPanel vue="avis" (non-admin / secours). */}
        {tab==="voyageurs-avis"&&isAdmin&&<div className="fbz-tab-content"><VoyageursAvisCtrl cfg={cfg} destinationAvisId={voyDest?.type==="avis"?voyDest.id:null} onDestinationConsommee={()=>setVoyDest(null)}/></div>}
        {/* Lot 6 : l'écran existant + les feuilles du proto par-dessus. */}
        {tab==="voyageurs-demandes"&&isAdmin&&<div className="fbz-tab-content"><VoyageursDemandesCtrl cfg={cfg}/></div>}
        {tab==="mes-taches"&&!isAdmin&&<div className="fbz-tab-wide"><MesTachesTab cfg={cfg}/></div>}
        {tab==="mes-taches"&&isAdmin&&!ancienOuvert("mes-taches")&&<OperationsTaches onAncien={() => setAncienEcran("mes-taches")}/>}
        {tab==="mes-taches"&&isAdmin&&ancienOuvert("mes-taches")&&<div className="fbz-tab-wide">{retourNouveau}<JourTachesCtrl cfg={cfg} currentUser={currentUser}/></div>}
        {/* LOT 4 (2026-08-28) — la destination ⌂ Logements : liste « Le parc »
            + fiche à dix sous-onglets du proto. LogementsV2 porte la même
            mécanique de brouillon que l'ancien panel (useParcDraft). */}
        {tab==="logements"&&<div className="fbz-tab-content"><LogementsV2 cfg={cfg} save={saveCfg} data={data} saveData={saveData} factLog={factLog} saveLog={saveLog} invoicesList={invoicesList} invoicesRaw={invoicesRaw} incidents={incidents}/></div>}
        {/* P-4.24 — l'Accueil NEST (maquette v677), lu par les portes du serveur. */}
        {tab==="accueil" && isAdmin && !ancienOuvert("accueil") && <EcranAccueil onAller={setTab} onAncien={() => setAncienEcran("accueil")} onOuvrirFil={(id) => { setVoyDest({ type: "thread", id }); setTab("messages") }}/>}
        {tab==="accueil" && isAdmin && ancienOuvert("accueil") && <div className="fbz-tab-content">{retourNouveau}<AccueilAdmin cfg={cfg} blocksByMonth={blocksByMonth} onNavigate={setTab} onAller={allerVers} currentUser={currentUser}/></div>}
        {/* LOT 1 OPÉRATEUR (ADR-303) — l'écran des décisions. */}
        {tab==="operateur" && isAdmin && <div className="fbz-tab-content"><OperateurView cfg={cfg} onAller={allerVers}/></div>}
        {tab==="calendrier"&&!isAdmin&&<div className="fbz-tab-content"><CalendarPanel cfg={cfg} invalidatePricingBlocks={invalidatePricingBlocks}/></div>}
        {/* P-4.24 — le Calendrier NEST (maquette v677), lu par les portes du serveur. */}
        {tab==="calendrier"&&isAdmin&&!ancienOuvert("calendrier")&&<EcranCalendrier onAller={setTab} onAncien={() => setAncienEcran("calendrier")}/>}
        {tab==="calendrier"&&isAdmin&&ancienOuvert("calendrier")&&<div className="fbz-tab-content">{retourNouveau}<CalendarPanel cfg={cfg} invalidatePricingBlocks={invalidatePricingBlocks}/></div>}
        {/* P-3.48 — Réglages de la maquette v677, lus par une porte en liste blanche ; chaque geste reste sur l'ancien écran. */}
        {tab==="params"&&isAdmin&&<AvecAncienEcran
          nouvel={(ouvrir) => <EcranReglages manques={compterManques(cfg)} onAncien={ouvrir} onAccueil={() => setTab("accueil")}/>}
          ancien={(onglet) => isAdmin && <div className="fbz-tab-content"><ParamsPanel key={onglet} ongletInitial={onglet} cfg={cfg} save={saveCfg} data={data} saveData={saveData} currentUser={currentUser} callGetInvoiceSequences={callGetInvoiceSequences} callSetInvoiceSequence={callSetInvoiceSequence} callContractsOrphansList={callContractsOrphansList} callContractsOrphansDelete={callContractsOrphansDelete}/></div>}/>}
       </GardeEcran>
      </div>
    </div>
  )
}
